import { render, staticRenderFns } from "./CustomerBankAccount.vue?vue&type=template&id=2bf73d0f&scoped=true&"
import script from "./CustomerBankAccount.vue?vue&type=script&lang=js&"
export * from "./CustomerBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBankAccount.vue?vue&type=style&index=0&id=2bf73d0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf73d0f",
  null
  
)

export default component.exports